import React from 'react';
import { connect } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { APP_BASE_URL_2 } from '../../../services/TapApiUrls';
import Ax from '../../../components/hoc/Ax';
import tapIcon from '../../../services/TapIcon';
import { Modal } from 'bootstrap';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import moment from "moment";
import AppBaseComponent from '../../../components/AppBaseComponent';
import uuid from 'react-uuid';
import InputPurchaseSearch from '../../includes/ui/InputPurchaseSearch';
import InputInventoryTransferSearch from '../../includes/ui/InputInventoryTransferSearch';
import InputPurchaseOrderSearch from '../../includes/ui/InputPurchaseOrderSearch';
import ExpenseHeadJsx from './ExpenseHeadJsx';

class LogisticEditModal extends AppBaseComponent {
    
    constructor(props) {
        super(props);

        this.initialLinkingData         =   {
            purchase_transaction_ids        :   [],
            inv_transfer_transaction_ids    :   [],
            purchase_order_transaction_ids  :   [],
        };

        this.state                      =   {
            editFormSubmitting              :   false,
            loading_form                    :   false,
            addNewDistrict                  :   false,
            addNewPinCode                   :   false,

            paymentMode                     :   [],
            transportersList                :   [],
            cnfAgentsList                   :   [],
            handlersList                    :   [],

            divisionsList                   :   [],
            modalType                       :   '', 
            logisticDetail                  :   {...this.initialLinkingData},   
            transport_days                  :   '',   
            
            // linkingData                     :   {...this.initialLinkingData},
            searchedPurchase                :   [],
            searchedInvTransfer             :   [],
            searchedOrderPurchase           :   [],

            allLoadTypeFor                  :   [],
            loadTypes                       :   [],
            vehicleTypes                    :   [],
            materialTypes                   :   [],
            consignmentTypes                :   [],
            
            cnf                             :   {},
            billing                         :   {},
            consigment                      :   {},
            tracking                        :   {},
            purchaseInventory               :   {},
            allUsers                        :   [],
            expense_head                    :   [],

            editFieldData                   :   null,

            expense_details                 :   [],
            
        };

        this.domesticLoadType   =   [      
            {value: 'FULL TRUCK CONSIGNMENT', label: 'FULL TRUCK CONSIGNMENT'},
            {value: 'PARTIAL CONSIGNMENT', label: 'PARTIAL CONSIGNMENT'},
            {value: 'COURIER CONSIGNMENT', label: 'COURIER CONSIGNMENT'}
        ];
        this.internationalLoadType   =   [      
            {value: 'AIR CARGO', label: 'AIR CARGO'},
            {value: 'SEA CARGO', label: 'SEA CARGO'}
        ];
        this.unitOfMeasurement     =   [
            {value: "Tonne", label: "Tonne"},
            {value: "Kilogram", label: "Kilogram"}
        ]
        
        this.priority               =   [
            {value: "High", label: "High"},
            {value: "Medium", label: "Medium"},
            {value: "Low", label: "Low"},            
        ];

        this.modalId            =   uuid();   
        this.logisticUrl        =   APP_BASE_URL_2 + '/logistic';
       
    }
    
  
    componentDidMount(){
        this.addModal                  =   new Modal(document.getElementById(this.modalId), {keyboard: false, backdrop :false});
    }

    showModalInit           =   (type)  =>  {
        const logisticDetail    =   this.props.LogisticDetail;
        const allFields         =   this.props.allFields;
        
        this.setState({
            loading_form    :   true,
            modalType       :   type,
            logisticDetail  :   {...logisticDetail},
            expense_details :   type === 'Expense' && logisticDetail.expense_data ? logisticDetail.expense_data.map(d => ({expense_head_id: d.expense_head_id, amount : parseFloat(d.amount), notes : d.notes})) : []
        });
        
        let data = {};
        allFields && allFields.length > 0 && allFields.map(field => {
        switch(field) {
            case "logistic_type" :
                data = {...data, logistic_type : logisticDetail.logistic_type};
                break;   
            case "division" :
                data = {...data, division_id : logisticDetail.division_id};
                break;   
            case "type_of_load" :
                data = {...data, load_type : logisticDetail.load_type_id};
                break; 
            case "type_of_vehicle" :
                data = {...data, type_of_vehicle : logisticDetail.vehicle_type_id};
                break; 
            case "transporter_name" :
                data = {...data, transporter_id : logisticDetail.transporter_id};
                break;
            case "consigment_number" :
                data = {...data, consigment_number : logisticDetail.consigment_number};
                break;
            case "date_of_dispatch" :
                data = {...data, dispatch_date : logisticDetail.dispatch_date};
                break;
            case "expected_delivery_date" :
                data = {...data, delivery_date : logisticDetail.delivery_date};
                break;
            case "booking_place" :
                data = {...data, booking_place : logisticDetail.booking_place};
                break;
            case "vehicle_number" :
                data = {...data, vehicle_number : logisticDetail.vehicle_number};
                break;
            case "weight" :
                data = {...data, weight : logisticDetail.weight};
                break;
            case "unit_of_measurement" :
                data = {...data, unit_of_measurement : logisticDetail.unit_of_measurement};
                break;
            case "no_of_boxes" :
                data = {...data, number_of_boxes : logisticDetail.number_of_boxes};
                break;
            case "driver_name" :
                data = {...data, driver_name : logisticDetail.driver_name};
                break;
            case "driver_contact_number" :
                data = {...data, driver_contact_number : logisticDetail.driver_contact_number};
                break;
            case "delivery_date_at_godown" :
                data = {...data, delivery_date_at_godown : logisticDetail.delivery_date_at_godown};
                break;
            case "delivery_date_at_site" :
                data = {...data, delivery_date_at_site : logisticDetail.delivery_date_at_site};
                break;
            // case "transport_days" :
            //     data = {...data, };
            //     break;
            case "receiver_name" :
                data = {...data, receiver_name : logisticDetail.receiver_name};   
                break;
            case "invoice_number" :
                data = {...data, gst_invoice_number : logisticDetail.gst_invoice_number};   
                break;
            case "invoice_date" :
                data = {...data, invoice_date : logisticDetail.invoice_date};   
                break;
            case "invoice_value" :
                data = {...data, invoice_value : logisticDetail.invoice_value};   
                break;
            case "eway_bill_number" :
                data = {...data, eway_bill_number : logisticDetail.eway_bill_number};   
                break;
            case "payment_mode" :
                data = {...data, payment_mode : logisticDetail.payment_mode};   
                break;
            case "payment_date" :
                data = {...data, payment_date : logisticDetail.payment_date};   
                break;
            case "material_description" :
                data = {...data, machinery_description : logisticDetail.machinery_description};   
                break;
            // case "total_cost" :
            //     data = {...data, };   
            //     break;
            case "cnf_agent" :
                data = {...data, cnf_agent_id : logisticDetail.cnf_agent_id};   
                break;
            case "material_handler_name" :
                data = {...data, handler_id : logisticDetail.handler_id};   
                break;
            case "boe_number" :
                data = {...data, boe_number : logisticDetail.boe_number};   
                break;
            case "consignment_type" :
                data = {...data, consignment_type: logisticDetail.consignment_type_id};   
                break;
            case "date_of_requirement" :
            case "priority" :
            case "material_type" :
            case "load_dimensions" :
            case "load_description" :
                data = {...data, 
                    date_of_requirement : logisticDetail.date_of_requirement, 
                    priority : logisticDetail.priority, 
                    load_dimensions : logisticDetail.load_dimensions, 
                    load_description : logisticDetail.load_description, 
                    material_type : logisticDetail.material_type_id
                };   
                break;
        }
        });

        if(type === 'Purchase & Inventory') {
            this.setState({
                purchaseInventory: {
                    purchase_transaction_ids : logisticDetail.purchase_transaction_ids,
                    purchase_order_transaction_ids : logisticDetail.purchase_order_transaction_ids,
                    inv_transfer_transaction_ids : logisticDetail.inv_transfer_transaction_ids,
                    users : logisticDetail.usersList && logisticDetail.usersList.length > 0 ? logisticDetail.usersList.map(u => u.enc_id) : []
                },
                searchedPurchase:   logisticDetail.purchase_transaction_ids && logisticDetail.purchase_transaction_ids.map((p,i) => {
                    return {
                        transaction_id : p,
                        label : p,
                        value : p
                    }
                }),
                searchedOrderPurchase:   logisticDetail.purchase_order_transaction_ids && logisticDetail.purchase_order_transaction_ids.map((p,i) => {
                    return {
                        transaction_id : p,
                        label : p,
                        value : p
                    }
                }),
                searchedInvTransfer:   logisticDetail.inv_transfer_transaction_ids && logisticDetail.inv_transfer_transaction_ids.map((p,i) => {
                    return {
                        transaction_id : p,
                        label : p,
                        value : p
                    }
                }),
            }, () => {
                this.addModal.show();
            })
        }else {
            this.setState({
                editFieldData : { ...data}
            }, () => {
                this.addModal.show();
            });
        }
        
        if(['Transaction', 'Consigment', 'Billing', 'C&F', 'Purchase & Inventory', 'Expense'].includes(type)) {
            HttpAPICall.withAthorization('GET', `${this.logisticUrl}/form_data`, this.props.access_token, null, null, (response) => {
                const formData                   =   response.data;

                let expense_head    =   [];
                if(logisticDetail.logistic_type === 'International') {
                    expense_head        =   formData.expense_head.filter(eh => logisticDetail.logistic_type === 'International' && ['international', 'dom_inter'].includes(eh.head_type));
                }else {
                    expense_head        =   formData.expense_head.filter(eh => logisticDetail.logistic_type === 'Domestic' && ['domestic', 'dom_inter'].includes(eh.head_type));
                }

                this.setState({
                    paymentMode                 :   formData.payment_mode,
                    logisticStatus              :   formData.status.map((s) => { return { value: s.id, label: s.name}}), 
                    transportersList            :   formData.transporter.map((s) => { return { value: s.id, label: `${s.name}`}}),       
                    cnfAgentsList               :   formData.cnfAgent.map((s) => { return { value: s.id, label: `${s.name}`}}),       
                    divisionsList               :   formData.division.map((s) => { return { value: s.id, label: `${s.name}`}}),       
                    handlersList                :   formData.handler.map((s) => { return { value: s.id, label: `${s.name}`}}),    
                    allUsers                    :   formData && formData.users ? formData.users.map((s) => { return {value: s.id, label: s.full_name,site_ids:s.linked_sites}; }) : [], 
                    
                    allLoadTypeFor              :   formData.load_type ? formData.load_type.map((lt) => { return {value: lt.id, label: lt.name, load_type: lt.load_type}; }) : [],
                    loadTypes                   :   formData.load_type ? formData.load_type.map((lt) => { return {value: lt.id, label: lt.name, load_type: lt.load_type}; }) : [],
                    vehicleTypes                :   formData.vehicle_type ? formData.vehicle_type.map((vt) => { return {value: vt.id, label: vt.name}; }) : [],
                    materialTypes               :   formData.material_type ? formData.material_type.map((mt) => { return {value: mt.id, label: mt.name}; }) : [],
                    consignmentTypes            :   formData.consignment_type ? formData.consignment_type.map((ct) => { return {value: ct.id, label: ct.name}; }) : [],

                    expense_head
                }, () => {
                    if(logisticDetail.logistic_type === 'International') {
                        this.setState({
                            loadTypes : this.state.allLoadTypeFor.filter(lt => ['dom_inter', 'international'].includes(lt.load_type)),
                        });
                    }else {
                    this.setState({
                            loadTypes : this.state.allLoadTypeFor.filter(lt => ['dom_inter', 'domestic'].includes(lt.load_type)),
                        });
                    }
                });
            }).then(() => { this.setState({ loading_form: false}) });
        }else {
            this.setState({ loading_form: false});
        }
        
    }


    //submit Edit Form
    editLogisticFormSubmit      =   (e) =>  {
        e.preventDefault();
        let data        =   {id : this.state.logisticDetail.id}
        const {editFieldData, expense_details}    =   this.state;
        if(this.state.modalType === "Purchase & Inventory") {
            data        =   {...data, ...this.state.purchaseInventory}
        }else{
            data        =   {...data, ...editFieldData}
        }
        

        if(expense_details.length > 0) {
            data        =   {...data, expense_details, total_cost : expense_details.reduce((total, item) => total + parseFloat(item.amount), 0)}
        }
        this.setState({editFormSubmitting : true});    
        HttpAPICall.withAthorization('PUT', `${this.logisticUrl}/edit`, this.props.access_token, null, data, (response) => {
            this.setState({
                editFieldData : null
            });
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.props.getLogisticViewDetails(this.state.logisticDetail.transaction_id);
            this.addModal.hide();
        }).then(() => this.setState({ editFormSubmitting: false }));

    }
   
    selectOptionsData   =   (field) => {
        switch(field) {
            case 'division' :
                return {key : 'division_id', name : 'Division', data : this.state.divisionsList, required: false, isMulti: false};

            case 'type_of_load' :
                // this.state.internationDataLoad ? this.internationalLoadType.find(s => s.value == this.state.addLogisticForm.load_type) : this.domesticLoadType.find(s => s.value == this.state.addLogisticForm.load_type)
                // this.state.internationDataLoad ? this.internationalLoadType : this.domesticLoadType
                return {key : 'load_type', name : 'Type of Load', data : this.state.loadTypes, required: true, isMulti: false};

            case 'tag_users' :
                return {key : 'users', name : 'Tag Users', data : this.state.allUsers, required: false, isMulti: true};
            
            case 'type_of_vehicle' :
                return {key : 'type_of_vehicle', name : 'Type of Vehicle', data : this.state.vehicleTypes, required: false, isMulti: false};

            case 'transporter_name' :
                return {key : 'transporter_id', name : 'Courier/Transporter Name', data : this.state.transportersList, required: false, isMulti: false};

            case 'payment_mode' :
                return {key : 'payment_mode', name : 'Payment Mode', data : this.state.paymentMode, required: false, isMulti: false};

            case 'priority' :
                return {key : 'priority', name : 'Priority', data : this.priority, required: false, isMulti: false};

            case 'material_type' :
                return {key : 'material_type', name : 'Material Type', data : this.state.materialTypes, required: false, isMulti: false};

            case 'consignment_type' :
                return {key : 'consignment_type', name : 'Consignment Type', data : this.state.consignmentTypes, required: false, isMulti: false};


            default :
                return {key : '', name : '', data : [], required: false, isMulti: false};
        }
    }

    handleLogisticType              =   (type)  =>  {
        if(type === "domestic") {
            this.setState({
                loadTypes : this.state.allLoadTypeFor.filter(lt => ['dom_inter', 'domestic'].includes(lt.load_type)),
                editFieldData : {
                    ...this.state.editFieldData,
                    load_type : "",
                }
            });
        }else if(type === "international") {
            this.setState({
                loadTypes : this.state.allLoadTypeFor.filter(lt => ['dom_inter', 'international'].includes(lt.load_type)),
                editFieldData : {
                    ...this.state.editFieldData,
                    load_type : "",
                }
            });
        }
    }

    handleExpenseHeadData       =   (id, name, value)  => {
        console.log(id, name, value);

        let data            =   {
            expense_head_id     :   id, 
            [name]              :   name === 'amount' ? parseFloat(value) : value
        }
        let expense_details =   this.state.expense_details;
        this.setState({
            expense_details     :   expense_details.find(d => d.expense_head_id == id) 
                                    ? 
                                        expense_details.map(d => (d.expense_head_id == id ? {...d, ...data} : d))
                                    :   [...expense_details, data]
        });
    }


    //*********************************ITEM ADD JSX*********************** */
    modalJsx                     =   ()  =>  {
        const logisticDetail            =   this.state.logisticDetail;
        const {allFields}               =   this.props;

        return (
            <div className="modal fade" id={this.modalId} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content  ">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addModalLabel">Edit {this.state.modalType}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => this.setState({editFieldData : null})}></button>
                        </div>
                        <div className="modal-body ">
                            {
                            this.state.loading_form 
                            ? 
                            <Loader/>
                            : 
                            <form onSubmit={this.editLogisticFormSubmit} id="editAddressForm" method="post" encType="multipart/form-data">
                                
                            <div className="row align-items-center my-3">
                                {
                                    this.state.modalType === 'Expense' 
                                    ?
                                    <>
                                        <div className="col-sm-4 mt-3 text-center">Head</div>
                                        <div className="col-sm-2 mt-3 text-center">Amount</div>
                                        <div className="col-sm-6 mt-3 text-center">Notes</div>
                                        <ExpenseHeadJsx expense_head={this.state.expense_head} handleExpenseHeadData={this.handleExpenseHeadData} expense_data={this.state.expense_details}/>
                                        <div className="col-sm-4 my-3">
                                            <label htmlFor="site_id" className="form-label ">Total Cost</label>
                                        </div>
                                        <div className="col-sm-2 my-3">
                                            <input
                                                type="text"
                                                className="form-control text-end"
                                                autoComplete="off"
                                                disabled={true}
                                                value={this.state.expense_details.filter(d => d.amount).reduce((total, item) => total + parseFloat(item.amount), 0)}
                                                placeholder="Enter Total Cost"
                                            />
                                        </div>
                                    </>
                                    :
                                    allFields && allFields.length > 0 && allFields.map(field => {
                                        const {key, name, data, required, isMulti}  =   this.selectOptionsData(field);
                                        return (
                                            <>
                                                {
                                                    field === "logistic_type" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label">Logistic Type</label>
                                                        </div>
                                                        <div className="col-sm-10 mt-3">
                                                            <div className="row">
                                                                <div className="col-sm-5">
                                                                    <input
                                                                        name="logistic_type"
                                                                        type="radio"
                                                                        value={"Domestic"}
                                                                        required={true}
                                                                        onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                        className="form-check-input"
                                                                        checked={this.state.editFieldData?.logistic_type === 'Domestic' ? true : false}
                                                                        id="domestic"
                                                                        onClick={() => this.handleLogisticType("domestic")}
                                                                    />
                                                                    <label className="form-check-label mx-2" htmlFor="domestic">Domestic</label>
                                                                </div>
                                                                <div className="col-sm-5">
                                                                    <input
                                                                        name="logistic_type"
                                                                        type="radio"
                                                                        required={true}
                                                                        value={"International"}
                                                                        onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                        className="form-check-input"
                                                                        checked={this.state.editFieldData?.logistic_type === 'International' ? true : false}
                                                                        id="international"
                                                                        onClick={() => this.handleLogisticType("international")}
                                                                    />
                                                                    <label className="form-check-label mx-2" htmlFor="international">International</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "division" &&
                                                    <>
                                                        <div className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Division</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <TapSelect
                                                                changeEvent={(selectedOption) => {
                                                                    this.tapSelectChange(selectedOption, 'editFieldData', 'division_id');
                                                                }}
                                                                options={this.state.divisionsList}
                                                                value={this.state.divisionsList.find(s => s.value == this.state.editFieldData?.division_id)}
                                                                isSearchable={true}
                                                                isClearable={false}
                                                                placeholder="Select Division"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    ["type_of_load", "type_of_vehicle", "priority", "material_type", 'consignment_type'].includes(field) &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor={key} className={`form-label ${required ? 'require' : ''}`}>{name}</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <TapSelect
                                                                changeEvent={(selectedOption) => {
                                                                    this.tapSelectChange(selectedOption, 'editFieldData', key);
                                                                }}
                                                                options={data}
                                                                isSearchable={true}
                                                                isClearable={true}
                                                                isMulti={isMulti}
                                                                required={required}
                                                                value={isMulti ? data.filter(t => this.state.editFieldData?.[key].includes(t.value)) : data.find(s => s.value == this.state.editFieldData?.[key])}
                                                                placeholder={`Select ${name}`}
                                                            />
                                                        </div>
                                                    </>  
                                                }

                                                {
                                                    field === "date_of_requirement" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Date of Requirement</label>
                                                        </div>
                                                        <div className="col-sm-4 add_calender_section mt-3">
                                                            <DatePicker
                                                                selected={
                                                                    this.state.editFieldData?.date_of_requirement
                                                                        ? moment(this.state.editFieldData?.date_of_requirement, 'YYYY-MM-DD').toDate()
                                                                        : false
                                                                }
                                                                onChange={(value, event) => this.formDateHandler('date_of_requirement', value, 'editFieldData')}
                                                                name="date_of_requirement"
                                                                dateFormat="dd-MMM-yyyy"
                                                                className={"form-control"}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                autoComplete="off"
                                                                scrollMonthYearDropdown
                                                                placeholderText={`Enter Date of Requirement`}
                                                            />
                                                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="Delivery Date" className="add_calender-icon" />
                                                        </div>
                                                    </>
                                                }

                                                {
                                                field ===  "load_description"  &&
                                                <>
                                                    <div className="col-sm-2 mt-3">
                                                        <label htmlFor="load_description" className="form-label">Load Description</label>
                                                    </div>
                                                    <div className="col-sm-4 mt-3">
                                                        <textarea
                                                            name="load_description"
                                                            value={this.state.editFieldData?.load_description}
                                                            onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                            id="load_description"
                                                            className="form-control"
                                                            placeholder="Please Add Load Description"
                                                            style={{ height: "75px" }}
                                                        />
                                                    </div>
                                                </>
                                                }
                                                {
                                                field === 'load_dimensions' &&
                                                <>
                                                    <div className="col-sm-2 mt-3">
                                                        <label htmlFor='load_dimensions' className="form-label">Load Dimensions</label>
                                                    </div>
                                                    <div className="col-sm-1 mt-3">
                                                        L
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            autoComplete="off"
                                                            value={this.state.editFieldData?.load_dimensions.l}
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    editFieldData :   {
                                                                        ...this.state.editFieldData,
                                                                        load_dimensions : {...this.state.editFieldData.load_dimensions, l : e.target.value}
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-sm-1 mt-3">
                                                        W
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            autoComplete="off"
                                                            value={this.state.editFieldData?.load_dimensions.w}
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    editFieldData :   {
                                                                        ...this.state.editFieldData,
                                                                        load_dimensions : {...this.state.editFieldData.load_dimensions, w : e.target.value}
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-sm-1 mt-3">
                                                        H
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            autoComplete="off"
                                                            value={this.state.editFieldData?.load_dimensions.h}
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    editFieldData :   {
                                                                        ...this.state.editFieldData,
                                                                        load_dimensions : {...this.state.editFieldData.load_dimensions, h : e.target.value}
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-sm-1 mt-3 text-end"></div>
                                                </>
                                            }


                                                {
                                                    field === "transporter_name" &&
                                                    <>
                                                    <div className="col-sm-2 mt-3">
                                                        <label htmlFor="site_id" className="form-label ">Courier/Transporter Name</label>
                                                    </div>
                                                    <div className="col-sm-4 mt-3">
                                                        <TapSelect
                                                            changeEvent={(selectedOption) => {
                                                                this.tapSelectChange(selectedOption, 'editFieldData', 'transporter_id');
                                                            }}
                                                            options={this.state.transportersList}
                                                            value={this.state.transportersList.find(s => s.value == this.state.editFieldData?.transporter_id)}
                                                            isSearchable={true}
                                                            isClearable={true}
                                                            placeholder="Select Courier/Transporter"
                                                        />
                                                    </div>
                                                    </>
                                                }
                                                {
                                                    field === "consigment_number" &&
                                                    <>
                                                    <div className="col-sm-2 mt-3">
                                                        <label htmlFor="site_id" className="form-label ">Consigment Number</label>
                                                    </div>
                                                    <div className="col-sm-4 mt-3">
                                                        <input
                                                            name="consigment_number"
                                                            type="text"
                                                            className="form-control"
                                                            autoComplete="off"
                                                            onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                            value={this.state.editFieldData?.consigment_number}
                                                            placeholder="Enter Consigment Number"
                                                        />
                                                    </div>
                                                    </>
                                                }
                                                {
                                                    field === "expected_delivery_date" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Expected Delivery Date</label>
                                                        </div>
                                                        <div className="col-sm-4 add_calender_section mt-3">
                                                            <DatePicker
                                                                selected={
                                                                    this.state.editFieldData?.delivery_date
                                                                        ? moment(this.state.editFieldData?.delivery_date, 'YYYY-MM-DD').toDate()
                                                                        : false
                                                                }
                                                                onChange={(value, event) => this.formDateHandler('delivery_date', value, 'editFieldData')}
                                                                name="delivery_date"
                                                                dateFormat="dd-MMM-yyyy"
                                                                className={"form-control"}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                autoComplete="off"
                                                                scrollMonthYearDropdown
                                                                placeholderText={`Enter Delivery Date`}
                                                            />
                                                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="Delivery Date" className="add_calender-icon" />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "booking_place" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Booking Place</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <input
                                                                name="booking_place"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                value={this.state.editFieldData?.booking_place}
                                                                placeholder="Enter Booking Place"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "vehicle_number" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Vehicle Number</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <input
                                                                name="vehicle_number"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                value={this.state.editFieldData?.vehicle_number}
                                                                placeholder="Enter Vehicle Number"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "weight" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Weight</label>
                                                        </div>
                                                        <div className="col-sm-2 mt-3">
                                                            <input
                                                                name="weight"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                value={this.state.editFieldData?.weight}
                                                                placeholder="Enter Weight"
                                                            />
                                                        </div>
                                                        <div className="col-sm-2 mt-3">
                                                            <TapSelect
                                                                changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'editFieldData', 'unit_of_measurement');}}
                                                                options={this.unitOfMeasurement} 
                                                                id="unit_of_measurement"
                                                                isSearchable={true}
                                                                isClearable={true}
                                                                value={this.unitOfMeasurement.find(unit => unit.value === this.state.editFieldData?.unit_of_measurement)}
                                                                placeholder="Select Unit"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "no_of_boxes" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">No. of Boxes</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <input
                                                                name="number_of_boxes"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                value={this.state.editFieldData?.number_of_boxes}
                                                                placeholder="Enter No. of Boxes"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "driver_name" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Driver Name</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <input
                                                                name="driver_name"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                value={this.state.editFieldData?.driver_name}
                                                                placeholder="Enter driver name"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "driver_contact_number" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Driver Contact Number</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <input
                                                                name="driver_contact_number"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                value={this.state.editFieldData?.driver_contact_number}
                                                                placeholder="Enter driver contact number"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "delivery_date_at_godown" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Delivery Date at Godown</label>
                                                        </div>
                                                        <div className="col-sm-4 add_calender_section mt-3">
                                                            <DatePicker
                                                                selected={
                                                                    this.state.editFieldData?.delivery_date_at_godown
                                                                        ? moment(this.state.editFieldData?.delivery_date_at_godown, 'YYYY-MM-DD').toDate()
                                                                        : false
                                                                }
                                                                onChange={(value, event) => this.formDateHandler('delivery_date_at_godown', value, 'editFieldData')}
                                                                name="delivery_date_at_godown"
                                                                dateFormat="dd-MMM-yyyy"
                                                                className={"form-control"}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                autoComplete="off"
                                                                scrollMonthYearDropdown
                                                                placeholderText={`Enter Delivery Date at Godown`}
                                                            />
                                                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="Delivery Date at Godown" className="add_calender-icon" />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "delivery_date_at_site" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Delivery Date at Site</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3 add_calender_section mt-3">
                                                            <DatePicker
                                                                selected={
                                                                    this.state.editFieldData?.delivery_date_at_site
                                                                        ? moment(this.state.editFieldData?.delivery_date_at_site, 'YYYY-MM-DD').toDate()
                                                                        : false
                                                                }
                                                                onChange={(value, event) => {
                                                                    this.formDateHandler('delivery_date_at_site', value, 'editFieldData');
                                                                }}
                                                                name="delivery_date_at_site"
                                                                dateFormat="dd-MMM-yyyy"
                                                                className={"form-control"}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                autoComplete="off"
                                                                scrollMonthYearDropdown
                                                                placeholderText={`Enter Delivery Date at Site`}
                                                            />
                                                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="Delivery Date at Site" className="add_calender-icon" />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "receiver_name" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Receiver Name</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <input
                                                                name="receiver_name"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                value={this.state.editFieldData?.receiver_name}
                                                                placeholder="Enter Receiver Name"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "invoice_number" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Invoice Number</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <input
                                                                name="gst_invoice_number"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={this.state.editFieldData?.gst_invoice_number}
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                placeholder="Enter Invoice Number"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "invoice_date" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Invoice Date</label>
                                                        </div>
                                                        <div className="col-sm-4 add_calender_section mt-3">
                                                            <DatePicker
                                                                selected={
                                                                    this.state.editFieldData?.invoice_date
                                                                        ? moment(this.state.editFieldData?.invoice_date, 'YYYY-MM-DD').toDate()
                                                                        : false
                                                                }
                                                                onChange={(value, event) => this.formDateHandler('invoice_date', value, 'editFieldData')}
                                                                name="invoice_date"
                                                                dateFormat="dd-MMM-yyyy"
                                                                className={"form-control"}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                autoComplete="off"
                                                                scrollMonthYearDropdown
                                                                placeholderText={`Enter Invoice Date`}
                                                            />
                                                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="Invoice Date" className="add_calender-icon" />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "invoice_value" &&
                                                    <>
                                                    <div className="col-sm-2 mt-3">
                                                        <label htmlFor="site_id" className="form-label ">Invoice Value</label>
                                                    </div>
                                                    <div className="col-sm-4 mt-3">
                                                        <input
                                                            name="invoice_value"
                                                            type="text"
                                                            className="form-control"
                                                            autoComplete="off"
                                                            onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                            value={this.state.editFieldData?.invoice_value}
                                                            placeholder="Enter Invoice Value"
                                                        />
                                                    </div>
                                                    </>
                                                }
                                                {
                                                    field === "eway_bill_number" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Eway Bill Number</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <input
                                                                name="eway_bill_number"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={this.state.editFieldData?.eway_bill_number}
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                placeholder="Enter Eway Bill Number"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "payment_mode" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Payment Mode</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <TapSelect
                                                                changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'editFieldData', 'payment_mode');}}
                                                                options={this.state.paymentMode}
                                                                value={this.state.paymentMode.find(s => s.value == this.state.editFieldData?.payment_mode)}
                                                                isSearchable={true}
                                                                isClearable={true}
                                                                placeholder="Select Payment Mode"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "payment_date" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Payment Date</label>
                                                        </div>
                                                        <div className="col-sm-4 add_calender_section mt-3">
                                                            <DatePicker
                                                                selected={
                                                                    this.state.editFieldData?.payment_date
                                                                        ? moment(this.state.editFieldData?.payment_date, 'YYYY-MM-DD').toDate()
                                                                        : false
                                                                }
                                                                onChange={(value, event) => this.formDateHandler('payment_date', value, 'editFieldData')}
                                                                name="payment_date"
                                                                dateFormat="dd-MMM-yyyy"
                                                                className={"form-control"}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                autoComplete="off"
                                                                scrollMonthYearDropdown
                                                                placeholderText={`Enter Payment Date`}
                                                            />
                                                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="Payment Date" className="add_calender-icon" />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "material_description" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Machinery/Material Description</label>
                                                        </div>
                                                        <div className="col-sm-10 mt-3">
                                                            <input
                                                                name="machinery_description"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                value={this.state.editFieldData?.machinery_description}
                                                                placeholder="Enter Machinery / Material Description"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "cnf_agent" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">CHA Agent</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <TapSelect
                                                                changeEvent={(selectedOption) => {
                                                                    this.tapSelectChange(selectedOption, 'editFieldData', 'cnf_agent_id');
                                                                }}
                                                                options={this.state.cnfAgentsList}
                                                                value={this.state.cnfAgentsList.find(s => s.value == this.state.editFieldData?.cnf_agent_id)}
                                                                isSearchable={true}
                                                                isClearable={true}
                                                                placeholder="Select CHA Agent"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "material_handler_name" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Freight Forwarder Name</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <TapSelect
                                                                changeEvent={(selectedOption) => {
                                                                    this.tapSelectChange(selectedOption, 'editFieldData', 'handler_id');
                                                                }}
                                                                options={this.state.handlersList}
                                                                value={this.state.handlersList.find(s => s.value == this.state.editFieldData?.handler_id)}
                                                                isSearchable={true}
                                                                isClearable={true}
                                                                placeholder="Select Freight Forwarder"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "boe_number" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">BOE Number</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3">
                                                            <input
                                                                name="boe_number"
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={this.state.editFieldData?.boe_number}
                                                                onChange={(e) => this.formInputHandler(e, 'editFieldData')}
                                                                placeholder="Enter BOE Number"
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    field === "date_of_dispatch" &&
                                                    <>
                                                        <div className="col-sm-2 mt-3">
                                                            <label htmlFor="site_id" className="form-label ">Date of Dispatch</label>
                                                        </div>
                                                        <div className="col-sm-4 mt-3 add_calender_section">
                                                            <DatePicker
                                                                selected={
                                                                    this.state.editFieldData?.dispatch_date
                                                                        ? moment(this.state.editFieldData?.dispatch_date, 'YYYY-MM-DD').toDate()
                                                                        : false
                                                                }
                                                                name="dispatch_date"
                                                                onChange={(value, event) => this.formDateHandler('dispatch_date', value, 'editFieldData')}
                                                                dateFormat="dd-MMM-yyyy"
                                                                className={"form-control"}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                autoComplete="off"
                                                                scrollMonthYearDropdown
                                                                placeholderText={`Dispatch Date`}
                                                            />
                                                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="Dispatch Date" className="add_calender-icon" />
                                                        </div>
                                                    </>
                                                }
                                            </>
                                        )
                                    }) 
                                }
                            </div>
                                {
                                    this.state.modalType === "Purchase & Inventory"
                                    ?
                                    <div className="row align-items-center mt-3">
                                        <div className="col-sm-3">
                                            <label htmlFor="site_id" className="form-label ">Tag Users</label>
                                        </div>
                                        <div className="col-sm-8">
                                            <TapSelect
                                                changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'purchaseInventory', 'users')}
                                                options={this.state.allUsers}
                                                isSearchable={true}
                                                isClearable={true}
                                                isMulti={true}
                                                value={this.state.allUsers.filter(t => this.state.purchaseInventory.users.includes(t.value))}
                                                placeholder="Please Select User"
                                            />
                                        </div>
                                        <div className="col-sm-3 mt-3 col-form-label col-form-label-sm">
                                            <label htmlFor="site_id" className="form-label ">Purchase Order</label>
                                        </div>
                                        <div className="col-sm-8 mt-3">
                                        <InputPurchaseOrderSearch
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'purchaseInventory', 'purchase_order_transaction_ids');
                                                this.setState({ searchedOrderPurchase: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                            }}
                                            isMulti={true}
                                            menuPlacement="top"
                                            value={this.state.searchedOrderPurchase && this.state.searchedOrderPurchase.length > 0 ? this.state.searchedOrderPurchase : []}
                                        />
                                        </div>
                                        <div className="col-sm-3 col-form-label col-form-label-sm mt-3">
                                            <label htmlFor="site_id" className="form-label ">Purchase</label>
                                        </div>
                                        <div className="col-sm-8">
                                        <InputPurchaseSearch
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'purchaseInventory', 'purchase_transaction_ids');
                                                this.setState({ searchedPurchase: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                            }}
                                            isMulti={true}
                                            menuPlacement="top"
                                            value={this.state.searchedPurchase && this.state.searchedPurchase.length > 0 ? this.state.searchedPurchase : []}
                                        />
                                        </div>
                                        <div className="col-sm-3 col-form-label col-form-label-sm mt-3">
                                            <label htmlFor="site_id" className="form-label ">Inventory Transfer</label>
                                        </div>
                                        <div className="col-sm-8">
                                        <InputInventoryTransferSearch
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'purchaseInventory', 'inv_transfer_transaction_ids');
                                                this.setState({ searchedInvTransfer: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                            }}
                                            isMulti={true}
                                            menuPlacement="top"
                                            value={this.state.searchedInvTransfer && this.state.searchedInvTransfer.length > 0 ? this.state.searchedInvTransfer : []}
                                        />
                                        </div>
                                    </div> 
                                    :
                                    null
                                }
                            </form>
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" disabled={this.state.editFormSubmitting} className="btn btn-secondary mx-2" data-bs-dismiss="modal" onClick={() => this.setState({editFieldData : null})}>Cancel</button>
                            <button type="submit" disabled={this.state.editFormSubmitting} className="btn btn-primary" form="editAddressForm">
                                Submit {this.state.editFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    

    render() {
        return (<Ax>{this.modalJsx()}</Ax>);
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token
    };
};

export default connect(mapStateToProps,null, null, { forwardRef: true })(LogisticEditModal);